import { render, staticRenderFns } from "./MaterialCard.vue?vue&type=template&id=a1affc6c&scoped=true"
import script from "./MaterialCard.vue?vue&type=script&lang=js"
export * from "./MaterialCard.vue?vue&type=script&lang=js"
import style0 from "./MaterialCard.vue?vue&type=style&index=0&id=a1affc6c&prod&lang=sass"
import style1 from "./MaterialCard.vue?vue&type=style&index=1&id=a1affc6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1affc6c",
  null
  
)

export default component.exports